import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0790f15e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ticket-sales-items" }
const _hoisted_2 = { class: "ticket-sales-items__row" }
const _hoisted_3 = { class: "ticket-sales-items__row-title" }
const _hoisted_4 = { class: "ticket-sales-items__subrows" }
const _hoisted_5 = { class: "ticket-sales-items__validity-disclaimer" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

import { PropType } from 'vue'
import { PublicService } from '@/models/public/bookingWidget.model'
import { ExperienceTimeslot } from '@/models/public/service.model'
import { TRANSLATION_TYPE } from '@/enums/public'
import { ALERT_TYPES } from '@/enums/components'
import {
  formatCurrency,
  formatIntlTime,
  formatSecondsToDuration,
} from '@/utils/formatters'
import BaseIcon from '@/components/BaseIcon.vue'
import BaseNumberIncrementer from '@/components/BaseNumberIncrementer.vue'
import {
  ITicketItemDateAvailability,
  ITicketItemDateAvailabilityTimeslot,
  ITicketServiceItemPriceInformationBodyItem,
  ServiceTicketType,
} from '@/models/service/serviceTicket.model'


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketSalesItems',
  props: {
  selectedService: {
    type: Object as PropType<PublicService>,
    required: true,
  },
  selectedSlots: {
    type: Array as PropType<ExperienceTimeslot[]>,
    default: () => [],
  },
  selectedTimeslots: {
    type: Array as PropType<ITicketServiceItemPriceInformationBodyItem[]>,
    default: () => [],
  },
  availableTicketItems: {
    type: Array as PropType<ITicketItemDateAvailability[]>,
    default: () => [],
  },
  errors: {
    type: Object as PropType<Record<string, unknown> | undefined>,
    default: undefined,
  },
},
  emits: ["onTimeslotIncrement"],
  setup(__props, { emit }: { emit: ({
  (
    e: 'onTimeslotIncrement',
    ticketItem: ITicketItemDateAvailabilityTimeslot,
    increment: number,
  ): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const getTicketItemLabel = (ticketItem: ITicketItemDateAvailability) => {
  if (ticketItem.name?.content) {
    return ticketItem.name?.content
  }
  return ticketItem.name
}

const getTimeslotLabel = (timeslot: ITicketItemDateAvailabilityTimeslot) => {
  return `${formatCurrency(timeslot.price)} (${formatIntlTime(
    timeslot.start,
  )} - ${formatIntlTime(timeslot.end)})`
}

const findSelectedTimeslot = (
  timeslot: ITicketItemDateAvailabilityTimeslot,
): ITicketServiceItemPriceInformationBodyItem | undefined => {
  return props.selectedTimeslots.find(
    (slot: ITicketServiceItemPriceInformationBodyItem) =>
      timeslot.ticket_item === slot.ticket_item &&
      timeslot.start === slot.start &&
      timeslot.end === slot.end,
  )
}

const handleTimeslotIncrement = (
  timeslot: ITicketItemDateAvailabilityTimeslot,
  increment: number,
) => {
  emit('onTimeslotIncrement', timeslot, increment)
}

return (_ctx: any,_cache: any) => {
  const _component_AlertBanner = _resolveComponent("AlertBanner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availableTicketItems, (ticketItem) => {
      return (_openBlock(), _createElementBlock("div", {
        key: ticketItem.ticket_item,
        class: "ticket-sales-items__row-wrapper"
      }, [
        (ticketItem.timeslots.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createTextVNode(_toDisplayString(getTicketItemLabel(ticketItem)) + " ", 1),
                  (ticketItem.name?.type === _unref(TRANSLATION_TYPE).MACHINE)
                    ? (_openBlock(), _createBlock(BaseIcon, {
                        key: 0,
                        icon: "google-translate",
                        class: "ticket-sales-items__gt-icon"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticketItem.timeslots, (timeslot) => {
                    return (_openBlock(), _createBlock(BaseNumberIncrementer, {
                      key: timeslot.id,
                      label: getTimeslotLabel(timeslot),
                      amount: findSelectedTimeslot(timeslot)?.quantity || 0,
                      "min-amount": 0,
                      "max-amount": timeslot.available_quantity,
                      class: "ticket-sales-items__subrow",
                      onClickMinus: () => handleTimeslotIncrement(timeslot, -1),
                      onClickPlus: () => handleTimeslotIncrement(timeslot, 1)
                    }, null, 8, ["label", "amount", "max-amount", "onClickMinus", "onClickPlus"]))
                  }), 128))
                ])
              ]),
              (__props.errors?.sales_items?.[ticketItem.ticket_item])
                ? (_openBlock(), _createBlock(_component_AlertBanner, {
                    key: 0,
                    "alert-type": _unref(ALERT_TYPES).WARNING,
                    text: __props.errors?.sales_items?.[ticketItem.ticket_item][0],
                    class: "ticket-sales-items__alert"
                  }, null, 8, ["alert-type", "text"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                (ticketItem.type === _unref(ServiceTicketType).TIMESLOT)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('ticketValidity.disclaimer.validDuringWholeTimeslot')), 1))
                  : _createCommentVNode("", true),
                (ticketItem.type === _unref(ServiceTicketType).DURATION)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (ticketItem.is_duration_limited)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t(
                  'ticketValidity.disclaimer.validUntilIsLimitedByEndDynamic',
                  {
                    duration: _unref(formatSecondsToDuration)(ticketItem.duration),
                  },
                )), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t(
                  'ticketValidity.disclaimer.validUntilNotLimitedByEndDynamic',
                  {
                    duration: _unref(formatSecondsToDuration)(ticketItem.duration),
                  },
                )), 1))
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})